(() => {
 const dialog = document.getElementById('ubRewardsDialog');
 if (!dialog) return;
 document.addEventListener('click', event => {
  if (event.target.closest('[data-rewards-open]')) { event.preventDefault(); dialog.showModal(); }
  if (event.target.closest('[data-rewards-close]')) dialog.close();
  if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); }
 });
})();
